import "./index.css";

import { NotFound } from "@repo/ui";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { ParcoursGuard } from "./components/parcours-guard";
import { ParcoursView } from "./routes/parcours-view";
import { CreerParcoursCandidat } from "./routes/creer-parcours";

const router = createBrowserRouter([
  // IMPORTANT : déclarée AVANT /p/:id (route statique prioritaire)
  {
    path: "/c/:campagneId/new",
    element: <CreerParcoursCandidat />,
  },
  // Route candidat — authentification légère (nom de famille + parcoursId)
  {
    path: "/p/:id",
    element: <ParcoursGuard />,
    children: [
      {
        index: true,
        element: <ParcoursView />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
